import { useEffect, useRef } from 'react';
import { trackEvent } from '../firebase/config.js';
import { Events } from '../firebase/events.js';

/**
 * Fires pricing_section_view exactly once per page load, the moment the pricing section
 * scrolls into view — lets GA4 answer "how many people reached pricing vs. how many of
 * those actually clicked a plan" instead of only seeing a generic page_view for the whole
 * landing page. Returns a ref to attach to the pricing <section>.
 */
export function usePricingSectionView(page) {
    const ref = useRef(null);
    const firedRef = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el || typeof IntersectionObserver === 'undefined') return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (firedRef.current) return;
                if (entries.some((e) => e.isIntersecting)) {
                    firedRef.current = true;
                    try { trackEvent(Events.pricing_section_view, { page }); } catch (_) {}
                    observer.disconnect();
                }
            },
            { threshold: 0.4 },
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [page]);

    return ref;
}
